import { render, staticRenderFns } from "./unsettledAbnormalCustInfo.vue?vue&type=template&id=1803270b&scoped=true"
import script from "./unsettledAbnormalCustInfo.vue?vue&type=script&lang=js"
export * from "./unsettledAbnormalCustInfo.vue?vue&type=script&lang=js"
import style0 from "./unsettledAbnormalCustInfo.vue?vue&type=style&index=0&id=1803270b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803270b",
  null
  
)

export default component.exports